import type { BuilderConfig } from '@/types/builder';
import TimelineStickyScroll from './TimelineStickyScroll.vue';
import { timelineInputs } from './Timeline.builder';

export default {
    component: TimelineStickyScroll,
    description:
        'Timeline component that is sticky on the screen and scrolls & reveals the timeline events as the user scrolls.',
    inputs: [
        ...timelineInputs,
        {
            name: 'max',
            helperText: 'The maximum scroll distance of the timeline in px.',
            type: 'number',
            required: true,
        },
        {
            name: 'timelineStyles',
            helperText: 'CSS styles to customize the timeline container.',
            type: 'string',
        },
        {
            name: 'top',
            type: 'uiBlocks',
            defaultValue: [],
        },
        {
            name: 'bottom',
            type: 'uiBlocks',
            defaultValue: [],
        },
    ],
    shouldReceiveBuilderProps: {
        builderLinkComponent: false,
        builderBlock: true,
    },
} satisfies BuilderConfig;
